import React from 'react';
import * as ReactRouterDom from 'react-router-dom';
import * as Pages from 'pages';
import { Routing } from 'global/routing';
import { AuthGuard } from 'app/AuthGuard';
import { Header } from 'app/Header';
import { Footer } from 'app/Footer';
import { MainPageLayout } from 'app/MainPageLayout';
import { Box } from '@clariness/clarikit-react';
import { IdMeCallback } from 'app/IdMeCallback';
import { Auth0SsoCallback } from 'app/Auth0SsoCallback';

export const Routes: React.FC = () => (
  <ReactRouterDom.Switch>
    <ReactRouterDom.Route
      path={Routing.LOGIN.getPath()}
      component={Pages.Login}
    />

    <ReactRouterDom.Route
      path={Routing.REGISTER.getPath()}
      component={Pages.Register}
    />

    <ReactRouterDom.Route
      path={Routing.FORGOT_PASSWORD.getPath()}
      component={Pages.ForgotPassword}
    />

    <ReactRouterDom.Route
      path={Routing.CHANGE_PASSWORD.getPath()}
      component={Pages.ChangePassword}
    />

    <ReactRouterDom.Route
      path={Routing.IDME_CALLBACK.getPath()}
      component={IdMeCallback}
    />

    <ReactRouterDom.Route
      path={Routing.AUTH0_SSO_CALLBACK.getPath()}
      component={Auth0SsoCallback}
    />

    <ReactRouterDom.Route
      path={Routing.EXTERNAL_OIDC_REGISTRATION.getPath(':token')}
      component={Pages.ExternalOidcRegistration}
    />

    <AuthGuard>
      <MainPageLayout>
        <Header />

        <Box display="flex" style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <ReactRouterDom.Switch>
            <ReactRouterDom.Route exact path={Routing.BASE_URL.getPath()}>
              <ReactRouterDom.Redirect to={Routing.HOME.getPath()} />
            </ReactRouterDom.Route>

            <ReactRouterDom.Route
              path={Routing.HOME.getPath()}
              component={Pages.Home}
            />

            <ReactRouterDom.Route
              path={Routing.ACCOUNT.getPath()}
              component={Pages.Account}
            />

            <ReactRouterDom.Route
              path={Routing.REFERRAL_DETAILS.getPath(':id')}
              component={Pages.ReferralDetails}
            />

            <ReactRouterDom.Route
              path={Routing.HELP_CENTER.getPath()}
              component={Pages.HelpCenter}
            />
          </ReactRouterDom.Switch>
        </Box>

        <Footer />
      </MainPageLayout>
    </AuthGuard>
  </ReactRouterDom.Switch>
);
